import { useQuery } from '@tanstack/react-query';
import { ESportQueryKey, useSportStore } from 'entities/sport';

export const useSports = () => {
  const fetchSports = useSportStore(state => state.fetchSports);
  const sportList = useSportStore(state => state.list);

  const sportQuery = useQuery({
    queryKey: [
      ESportQueryKey.SPORTS,
    ],
    queryFn: fetchSports,
  });

  return {
    sportList,
    sportQuery
  };
};
